const state = {
    companyId: null,
    areaId: null,
};

const actions = {
    
};

const mutations = {
    setCompanyId(state, companyId) {
        state.companyId = companyId;
    },
    setAreaId(state, areaId) {
        state.areaId = areaId;
    },
};

const getters = {
    companyId(state) {
        return state.companyId;
    },
    areaId(state) {
        return state.areaId;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};